<template>
  <div class="pub-job">
    <div class="card">
        Card
    </div>
  </div>
</template>

<script>
import Points from "@/components/Points/Tag";

export default {
  name: "ServiceJob",
  props: ["job"],
  components: { Points },
  data: function() {
    return {
    };
  },
  async created() {
  }
};
</script>

<style scoped lang="scss">
.pub-option {
  float: left;
  width: 50%;
}

.card {
    min-height: 230px;
  background: #fff;
  box-shadow: 0px 1px 0.5rem rgba(116, 75, 75, 0.25);
  margin: 12px 20px;
  padding: 12px 0;
  padding-bottom: 0 !important;
  border-radius: 8px;
  font-family: "Source Sans Pro";
}

.pub-option-title {
  padding: 30px 0 0 0;
  font-size: 21pt;
  color: darken($color-blue, 5%);
  font-weight: 600;
  text-align: center;
}
.pub-option-description {
  font-size: 13pt;
  padding: 12px 60px 50px 60px;
}
</style>